import type { types } from "@fraction/shared";
import { AlertTriangle } from "lucide-react";
import { useCallback } from "react";

import { useOpenNotificationTarget } from "src/hooks/useOpenNotificationTarget";

import { NotificationCardLayout } from "./NotificationCardLayout";

export function CommitmentLetterRateMismatchCard({
  notification,
  onDismiss,
  count,
}: {
  notification: types.CommitmentLetterRateMismatchNotification;
  onDismiss: () => void;
  count?: number;
}) {
  const { openRoute } = useOpenNotificationTarget();
  const handleClick = useCallback(() => {
    openRoute(`/app/${notification.applicationId}`);
    onDismiss();
  }, [openRoute, notification.applicationId, onDismiss]);

  return (
    <NotificationCardLayout
      icon={AlertTriangle}
      iconBg="bg-red-100"
      iconColor="text-red-600"
      title="Commitment rate mismatch"
      applicationEid={notification.applicationEid}
      applicantNames={notification.applicantNames}
      onClick={handleClick}
      count={count}
    >
      <p className="text-sm font-medium text-foreground/90">{notification.filename}</p>
      <p className="text-xs text-muted-foreground">
        Document {notification.documentRate} · Current app {notification.applicationRate}
      </p>
    </NotificationCardLayout>
  );
}
